<template>
  <span
    class="einvoice-status-badge badge font-weight-bold"
    :class="[`badge-${variant}`, sizeClass]"
  >
    <i v-if="showIcon" :class="iconClass" class="mr-1"></i>
    {{ label }}
  </span>
</template>

<script>
import {
  EINVOICE_STATUS_NAME,
  EINVOICE_STATUS_VARIANT,
  EINVOICE_STATUS_ICON,
} from '@/utils/einvoice.enum';

export default {
  name: 'EInvoiceStatusBadge',
  props: {
    status: {
      type: Number,
      required: true,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'md',
      validator: (v) => ['sm', 'md', 'lg'].includes(v),
    },
  },
  computed: {
    label() {
      return EINVOICE_STATUS_NAME[this.status] || 'Không xác định';
    },
    variant() {
      return EINVOICE_STATUS_VARIANT[this.status] || 'secondary';
    },
    iconClass() {
      return EINVOICE_STATUS_ICON[this.status] || 'fas fa-question-circle';
    },
    sizeClass() {
      const map = { sm: 'badge-sm', md: '', lg: 'badge-lg' };
      return map[this.size] || '';
    },
  },
};
</script>

<style lang="scss" scoped>
.einvoice-status-badge {
  display: inline-flex;
  align-items: center;
  font-size: 0.78rem;
  padding: 0.3rem 0.6rem;
  border-radius: 0.375rem;
  font-weight: 600;
  letter-spacing: 0.01em;

  &.badge-sm {
    font-size: 0.7rem;
    padding: 0.15rem 0.4rem;
  }
  &.badge-lg {
    font-size: 0.88rem;
    padding: 0.35rem 0.7rem;
  }

  i {
    font-size: inherit;
  }
}
</style>
